export const USER_HAS_NO_ACTIVE_SELLERS = "USER_HAS_NO_ACTIVE_SELLERS";

type ApiError = {
  response?: {
    status?: number;
    data?: {
      code?: string;
    };
  };
};

export const getApiErrorCode = (error: unknown): string | undefined =>
  (error as ApiError)?.response?.data?.code;

export const getApiErrorStatus = (error: unknown): number | undefined =>
  (error as ApiError)?.response?.status;

export const handlePortalAccessError = async (
  error: unknown,
  dependencies: {
    signOut: () => Promise<unknown>;
    navigate: (
      path: string,
      options: {
        replace: true;
        state?: { errorCode: string };
      },
    ) => void;
  },
): Promise<boolean> => {
  if (getApiErrorStatus(error) === 401) {
    dependencies.navigate("/login", { replace: true });
    return true;
  }

  if (getApiErrorCode(error) === USER_HAS_NO_ACTIVE_SELLERS) {
    await dependencies.signOut();
    dependencies.navigate("/login", {
      replace: true,
      state: { errorCode: USER_HAS_NO_ACTIVE_SELLERS },
    });
    return true;
  }

  return false;
};
